import InputMask from 'react-input-mask'

import {
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  Select,
  Textarea,
} from '@chakra-ui/react'
import { useForm } from 'react-hook-form'
import { api } from 'services/api'
import aditionalProducts from 'utils/aditionalProducts'
import products from 'utils/products'
import estados from 'utils/estados'
import estadosCidades from 'utils/estados-cidades'

import { ArrowForwardIcon } from '@chakra-ui/icons'

import Layout from 'components/Layout/Default'
import Container from 'components/Container'

import * as S from './styles'
import { useEffect, useState } from 'react'
import { transformarParaUrlAmigavel } from '../index.page'
import Loading from 'pages/components/Loading'
import AlertComponent from 'pages/components/AlertComponent'
import { useRecaptcha } from 'utils/useRecaptcha'
import { sendBudget } from 'services/contato'
import { useRouter } from 'next/router'
import { findCityByUrl } from '../cities'
import Head from 'next/head'
import Image from 'next/image'

const getCorrectName = (name, province) => {
  const correctProvince = estadosCidades.find(
    (item) => item.sigla.toLocaleLowerCase() === province
  )

  const correctName = correctProvince.cidades.find(
    (item) => transformarParaUrlAmigavel(item) === name
  )

  return correctName
}

const Contato = ({ province, city, seo }) => {
  const { isValid, reply, question } = useRecaptcha()
  const router = useRouter()
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)

  const {
    register,
    handleSubmit,
    getValues,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      state: province,
      city: city,
    },
  })

  useEffect(() => {
    setValue('city', getCorrectName(city, province))
    setValue('state', province?.toUpperCase())
  })

  const onSubmit = async (data) => {
    setLoading(true)
    try {
      const payload = {
        'your-email': data.email,
        'your-name': data.name,
        userName: data.name,
        'your-subject': `Orçamento para ${data.name} de ${data.city}/${data.state}`,
        title: `Orçamento para ${data.name} de ${data.city}/${data.state}`,
        status: 'publish',
        fields: {
          ...data,
        },
      }
      await api.post('/budget', payload)

      const path = router.asPath

      const url = `${window.location.protocol}//${window.location.host}${path}`

      const emailPayload = {
        ...payload,
        ...payload.fields,
        url,
      }

      await sendBudget(emailPayload)

      setSuccess(true)
      setError(false)

      window?.scrollTo(0, 0)
      reset()
      setTimeout(() => {
        setSuccess(false)
      }, 5000)
    } catch (error) {
      setError(true)
      setSuccess(false)
      setTimeout(() => {
        setError(false)
        setSuccess(false)
      }, 5000)
    } finally {
      setLoading(false)
    }
  }

  const phone = register('phone')
  const cellphoneRef = register('cellphone')

  const handlePhoneChange = (e) => {
    phone?.onChange(e)
  }

  const handleCelularChange = (e) => {
    cellphoneRef?.onChange(e)
  }

  const transformToLowerCase = (value) => {
    if (!value) return value
    return value.toLocaleLowerCase()
  }

  const structuredData = {
    '@context': 'https://schema.org/',
    '@type': 'Product',
    name: `${seo?.title}`,
    image: [
      'https://admin.centraldagrama.com/wp-content/uploads/2024/04/entrega-imediata-comprar-grama.webp',
      'https://admin.centraldagrama.com/wp-content/uploads/2024/04/esmeralda-premium-comprar.webp',
      'https://admin.centraldagrama.com/wp-content/uploads/2024/04/grama-placas-esmeralda-premium.webp',
    ],
    description: `${seo?.description}`,
    sku: '0446310786',
    mpn: '925872',
    brand: {
      '@type': 'Thing',
      name: 'ACME',
    },
    review: {
      '@type': 'Review',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
        bestRating: '5',
      },
      author: {
        '@type': 'Person',
        name: 'Robert Pardim',
      },
    },
    aggregateRating: {
      '@type': 'AggregateRating',
      ratingValue: '5',
      reviewCount: '2183',
    },
    tags: [
      'comprar grama',
      'grama esmeralda',
      'grama batatais',
      'grama são carlos',
      'grama bermuda',
      'grama coreana',
      'grama santo agostinho',
    ],
    offers: {
      '@type': 'Offer',
      price: '2.99',
      priceCurrency: 'BRL',
      priceValidUntil: '2025-12-31',
      itemCondition: 'https://schema.org/NewCondition',
      availability: 'https://schema.org/InStock',
      seller: {
        '@type': 'Organization',
        name: 'Central da Grama',
      },
    },
    review: {
      '@type': 'Review',
      author: 'Leandro Medeiros',
      datePublished: '2021-04-04',
      reviewBody: 'Ótimo atendimento, entrega rápida e preço justo.',
      name: 'Ótimo atendimento',
      reviewRating: {
        '@type': 'Rating',
        ratingValue: '5',
      },
    },
  }

  console.log(seo)

  return (
    <Layout
      links={router.asPath}
      category={seo?.h1}
      categorySize="25px"
      title={seo?.title}
      description={seo?.description}
      keywords={`comprar grama ${transformToLowerCase(
        getCorrectName(city, province)
      )} ${province}, grama para ${transformToLowerCase(
        getCorrectName(city, province)
      )} ${province}, preço de grama ${transformToLowerCase(
        getCorrectName(city, province)
      )} ${province}, orçamento de grama ${transformToLowerCase(
        getCorrectName(city, province)
      )} ${province}, m2 de grama em ${transformToLowerCase(
        getCorrectName(city, province)
      )} ${province}`}
    >
      <Head>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredData) }}
        />
      </Head>
      <section>
        <Loading isLoading={loading} />
        <AlertComponent
          show={success}
          title="Formulário Enviado"
          status="success"
          description="Obrigado por entrar e solicitar um orçamento, em breve te retornaremos!"
        />

        <AlertComponent
          show={error}
          title="Oops"
          status="error"
          description="Houve um erro ao enviar, tente novamente mais tarde."
        />

        <Container>
          <S.Flex>
            <S.Left>
              <h2>Preencha o formulário abaixo</h2>
              <S.Form onSubmit={handleSubmit(onSubmit)}>
                <FormControl isInvalid={errors.name} mb="24px">
                  <Input
                    {...register('name', {
                      required: 'Este campo é obrigatório',
                    })}
                    type="text"
                    placeholder="Nome"
                  />
                  <FormErrorMessage>
                    {errors.name && errors.name.message}
                  </FormErrorMessage>
                </FormControl>
                <S.Grid gap="24px">
                  <FormControl isInvalid={errors.email}>
                    <Input
                      {...register('email', {
                        required: 'Este campo é obrigatório',
                        pattern: {
                          value: /\S+@\S+\.\S+/,
                          message: 'Digite um email válido',
                        },
                      })}
                      type="email"
                      placeholder="Email"
                    />
                    <FormErrorMessage>
                      {errors.email && errors.email.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.confirmarEmail}>
                    <Input
                      {...register('confirmarEmail', {
                        validate: (value) =>
                          value === getValues('email') ||
                          'Os emails não correspondem',
                      })}
                      type="email"
                      placeholder="Confirme seu email"
                    />
                    <FormErrorMessage>
                      {errors.confirmarEmail && errors.confirmarEmail.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.state}>
                    <Select
                      {...register('state', {
                        required: 'Este campo é obrigatório',
                      })}
                      placeholder="state"
                      disabled
                    >
                      {estados.map((item) => (
                        <option key={`estado-${item.sigla}`} value={item.sigla}>
                          {item.sigla}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.state && errors.state.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.city}>
                    <Input
                      {...register('city', {
                        required: 'Este campo é obrigatório',
                        minLength: {
                          value: 3,
                          message: 'O city deve ter pelo menos 3 caracteres',
                        },
                      })}
                      type="text"
                      placeholder="city p/ Entrega"
                      disabled
                    />
                    <FormErrorMessage>
                      {errors.city && errors.city.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.phone}>
                    <InputMask
                      mask="(99) 9999-9999"
                      maskChar=""
                      onChange={handlePhoneChange}
                      value={phone.value}
                      {...register('phone', {
                        required: 'Este campo é obrigatório',
                      })}
                    >
                      {() => (
                        <Input type="tel" placeholder="Telefone" name="phone" />
                      )}
                    </InputMask>

                    <FormErrorMessage>
                      {errors.phone && errors.phone.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.cellphone}>
                    <InputMask
                      mask="(99) 9 9999-9999"
                      maskChar=""
                      onChange={handleCelularChange}
                      value={cellphoneRef.value}
                      {...register('cellphone', {
                        required: 'Este campo é obrigatório',
                      })}
                    >
                      {() => (
                        <Input
                          type="tel"
                          placeholder="Celular"
                          name="cellphone"
                        />
                      )}
                    </InputMask>
                    <FormErrorMessage>
                      {errors.cellphone && errors.cellphone.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.grass}>
                    <Select
                      {...register('grass', {
                        required: 'Este campo é obrigatório',
                      })}
                      placeholder="Tipo da Grama"
                    >
                      {products.map((item) => (
                        <option value={item.label} key={item.label}>
                          {item.label}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.grass && errors.grass.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.quantity}>
                    <Input
                      {...register('quantity', {
                        required: 'Este campo é obrigatório',
                      })}
                      type="number"
                      placeholder="Quantidade (em m2)"
                    />
                    <FormErrorMessage>
                      {errors.quantity && errors.quantity.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.purpose_of_use}>
                    <Select
                      {...register('purpose_of_use', {
                        required: 'Este campo é obrigatório',
                      })}
                      placeholder="Finalidade de Utilização"
                    >
                      <option value="">
                        (escolha a finalidade de utilização)
                      </option>
                      <option value="Jardim">Jardim</option>
                      <option value="Campo de Futebol">Campo de Futebol</option>
                      <option value="Chácara">Chácara</option>
                      <option value="Condomínio">Condomínio</option>
                      <option value="Talude">Talude</option>
                      <option value="Obras Públicas">Obras Públicas</option>
                      <option value="Obras Privadas">Obras Privada</option>
                    </Select>
                    <FormErrorMessage>
                      {errors.purpose_of_use && errors.purpose_of_use.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.met_us}>
                    <Select
                      {...register('met_us')}
                      placeholder="Como chegou até nosso site?"
                    >
                      <option value="Não selecionado">Não selecionado</option>
                      <option value="Google">Google</option>
                      <option value="Bing">Bing</option>
                      <option value="Facebook">Facebook</option>
                      <option value="MercadoLivre">MercadoLivre</option>
                      <option value="OLX">OLX</option>
                      <option value="Outros">Outros</option>
                    </Select>
                    <FormErrorMessage>
                      {errors.met_us && errors.met_us.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.additional_services}>
                    <Select
                      {...register('additional_services')}
                      placeholder="Serviços adicionais"
                    >
                      <option value="Não selecionado">Não selecionado</option>
                      <option value="Execução do Plantio">
                        Execução de Plantio
                      </option>
                      <option value="Execução do Plantio">
                        Execução de Plantio + Limpeza
                      </option>
                      <option value="Execução do Plantio + Cobertura">
                        Execução do Plantio + Cobertura
                      </option>
                      <option value="Execução do Plantio + Limpeza + Cobertura">
                        Execução do Plantio + Limpeza + Cobertura
                      </option>
                    </Select>
                    <FormErrorMessage>
                      {errors.additional_services &&
                        errors.additional_services.message}
                    </FormErrorMessage>
                  </FormControl>

                  <FormControl isInvalid={errors.additional_products}>
                    <Select
                      {...register('additional_products')}
                      placeholder="Produtos adicionais"
                    >
                      <option value="Não selecionado">Não selecionado</option>
                      {aditionalProducts.map((item) => (
                        <option key={item.label} value={item.label}>
                          {item.label}
                        </option>
                      ))}
                    </Select>
                    <FormErrorMessage>
                      {errors.additional_products &&
                        errors.additional_products.message}
                    </FormErrorMessage>
                  </FormControl>
                </S.Grid>
                <FormControl isInvalid={errors.mensagem} mt="24px">
                  <Textarea
                    {...register('message')}
                    placeholder="Mensagem"
                    resize="none"
                  />
                  <FormErrorMessage>
                    {errors.message && errors.message.message}
                  </FormErrorMessage>
                </FormControl>

                <FormControl mt="24px" isInvalid={!isValid()}>
                  <FormLabel>{question}</FormLabel>

                  <Input
                    type="text"
                    placeholder="Digite aqui a resposta"
                    onChange={(event) => reply(event.target.value)}
                  />
                  <FormErrorMessage>
                    Por favor, responda a questão acima.
                  </FormErrorMessage>
                </FormControl>

                <S.Button disabled={!isValid() || loading} shape="rounded">
                  Enviar Orçamento <ArrowForwardIcon w={4} h={4} />
                </S.Button>
              </S.Form>

              <S.About>
                <S.Title>{`Comprar grama para ${seo?.local} ${seo?.uf} `}</S.Title>
                <S.TextContent>
                  Aqui você encontra gramas com melhor preço m² para entrega em{' '}
                  {seo?.local} {seo?.uf} . Estamos localizados próximo de
                  Angatuba SP, somos fornecedores atacadistas e trabalhamos com
                  quantidade mínima de 500 m² (seja para entrega ou retirada).
                </S.TextContent>
                <S.Title>{`Qual o melhor preço para ${seo?.local} ${seo?.uf} ?`}</S.Title>
                <S.TextContent>
                  Para receber seu orçamento de grama para {seo?.local}{' '}
                  {seo?.uf} , preencha todos os campos do
                  <strong> formulário acima</strong> e aguarde prazo máximo de
                  24 horas para resposta em seu e-mail ou para um retorno ainda
                  mais rápido, basta clicar em nosso
                  <a href="https://api.whatsapp.com/send/?phone=5511996172172&type=phone_number&app_absent=0">
                    <strong> Whatsapp</strong>
                  </a>
                  .
                </S.TextContent>
                <S.Title>{`Tipos de grama para ${seo?.local} ${seo?.uf}`}</S.Title>
                <S.TextContent>
                  Trabalhamos com os seguintes tipos de gramas (consulte
                  disponibilidade e preços): esmeralda, esmeralda premium,
                  batatais, batatais plus, são carlos, são carlos plus, bermuda
                  tifton, bermuda celebration, grama coreana e santo agostinho.
                </S.TextContent>
                <S.ImageContainer>
                  <Image
                    src="https://admin.centraldagrama.com/wp-content/uploads/2024/04/entrega-imediata-comprar-grama.webp"
                    alt="compre gramas com entrega imediata"
                    title="Entrega imediata em menos de 24 horas para cidades próximas."
                    layout="fill"
                    objectFit="cover"
                  />
                </S.ImageContainer>
                <S.Title>Qual grama comprar?</S.Title>
                <S.TextContent>
                  <strong> Esmeralda e Esmeralda Premium</strong>: Jardim
                  aberto, beira de piscina, taludes, minicampos, chácaras e
                  condomínios
                  <br />
                  <br />
                  <strong> Batatais, Batatais Plus</strong>: Beiras de rodovia,
                  obras públicas, taludes, platôs e aterros, pastagem, sítios e
                  locais rústicos
                  <br />
                  <br />
                  <strong>Bermuda Tifton</strong>, Celebration e Coreana: Campos
                  de futebol, campos de golf, campos esportivos em geral e
                  projetos paisagísticos.
                  <br />
                  <br />
                  <strong>São Carlos, São Carlos Plus e Santo Agostinho</strong>
                  : Jardins sombreados, praças, pomares, resorts e casas de
                  campo e litoral
                </S.TextContent>
                <S.Title>{`Após comprar grama para ${seo?.local} ${seo?.uf}, posso plantar a grama em no máximo quantos dias?`}</S.Title>
                <S.TextContent>
                  O recomendável é plantar a grama o quanto antes, mas ela pode
                  ficar armazenada até 15 dias após descarga, em local aberto e
                  arejado. Fazemos entregas no Nordeste por exemplo e só para
                  chegar o caminhão leva em média 7 dias úteis, ainda sim a
                  grama sobrevive.
                </S.TextContent>
                <S.ImageContainer>
                  <Image
                    src="https://admin.centraldagrama.com/wp-content/uploads/2024/04/esmeralda-premium-comprar.webp"
                    alt="comprar grama esmeralda premium"
                    title={`Comprar grama esmeralda premium para ${seo?.local} - ${seo?.uf}`}
                    layout="fill"
                    objectFit="cover"
                  />
                </S.ImageContainer>
                <S.Title>{`Qual o prazo de retorno para o orçamento da grama para ${seo?.local} ${seo?.uf} ?`}</S.Title>
                <S.TextContent>
                  Por telefone é imediato, pelo Whatsapp pode levar algumas
                  horas (dependendo do horário) e por e-mail 24 horas úteis.
                  Para agilizar o orçamento, pedimos para que informe o tipo de
                  grama, quantidade em metros quadrados e o local de entrega.
                </S.TextContent>
                <S.Title>{`Tem quantidade mínima para entrega em ${seo?.local} ${seo?.uf} ?`}</S.Title>
                <S.TextContent>
                  Sim, somos fornecedores atacadistas. O mínimo no atacado são
                  500 m², isso vale tanto para entrega como para retirada
                  também. Metragens menores você pode conseguir no varejo com
                  floriculturas, casas de paisagismo e jardinagem, gardens ou
                  CEASA/CEAGESP mais próximo.
                </S.TextContent>
                <S.ImageContainer>
                  <Image
                    src="https://admin.centraldagrama.com/wp-content/uploads/2024/04/grama-placas-esmeralda-premium.webp"
                    alt="comprar grama esmeralda premium"
                    title={`Grama Esmeralda com melhor preço para ${seo?.local} - ${seo?.uf}`}
                    layout="fill"
                    objectFit="cover"
                  />
                </S.ImageContainer>
                <S.Title>{`Qual prazo de entrega para ${seo?.local} ${seo?.uf} ?`}</S.Title>
                <S.TextContent>
                  O prazo de entrega começa a contar a partir da formalização do
                  pedido e emissão da nota fiscal e pode variar dependendo da
                  localidade de compra, variando de 2 a no máximo 10 dias úteis.
                </S.TextContent>
                <S.TableContainer>
                  <S.Table>
                    <thead>
                      <S.TableTr>
                        <S.TableTh scope="col">Estado</S.TableTh>
                        <S.TableTh scope="col">Prazo de entrega</S.TableTh>
                      </S.TableTr>
                    </thead>
                    <tbody>
                      <S.TableTr>
                        <S.TableTh scope="row">SP e PR</S.TableTh>
                        <S.TableTd>2 à 3 dias úteis</S.TableTd>
                      </S.TableTr>
                      <S.TableTr>
                        <S.TableTh scope="row">SC, MG, RJ, ES e MS</S.TableTh>
                        <S.TableTd>3 à 5 dias úteis</S.TableTd>
                      </S.TableTr>
                      <S.TableTr>
                        <S.TableTh scope="row">MT, RS, GO, DF e BA</S.TableTh>
                        <S.TableTd>5 à 7 dias úteis</S.TableTd>
                      </S.TableTr>
                      <S.TableTr>
                        <S.TableTh scope="row">
                          TO, MA, PI, PA, AP, RR, AM,
                          <br></br> AC, RO, CE, SE, AL, PE, PB, RN
                        </S.TableTh>
                        <S.TableTd>7 à 10 dias úteis</S.TableTd>
                      </S.TableTr>
                    </tbody>
                    <tfoot>
                      <S.TableTr></S.TableTr>
                    </tfoot>
                  </S.Table>
                </S.TableContainer>
                <S.Title>
                  {` Sou de ${seo?.local} ${seo?.uf}, onde posso retirar a grama? `}
                </S.Title>
                <S.TextContent>
                  Temos vários grameiros e vários pontos de coleta. Para
                  facilitar, passamos o endereço do posto de combustível que
                  fica no km 159 da Rodovia Raposo Tavares em Itapetininga SP.
                  Com a data de retirada combinada, enviamos a localização no
                  dia do carregamento.
                </S.TextContent>
                <S.Title>Quais são as nossas condições de pagamento?</S.Title>
                <S.TextContent>
                  <strong>
                    Boleto à vista, depósito ou transferência bancária. Também
                    temos PIX e parcelamos no cartão até em 12x + taxas. A
                    compra é 100% segura, utilizamos o PicPay, PagBank, PayPal
                    ou Mercado Pago.
                  </strong>
                </S.TextContent>
                <S.Title>Tags relacionadas:</S.Title>
                <S.TextLink
                  href={`https://centraldagrama.com/comprar-grama/${province}/${city}`}
                  title={`comprar grama ${city} ${province}`}
                >
                  comprar grama {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href={`https://centraldagrama.com/comprar-grama/${province}/${city}`}
                  title={`preço de grama ${city} ${province}`}
                >
                  preço de grama {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href={`https://centraldagrama.com/comprar-grama/${province}/${city}`}
                  title={`comprar grama esmeralda preço m² ${city} ${province}`}
                >
                  comprar grama esmeralda preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href={`https://centraldagrama.com/comprar-grama/${province}/${city}`}
                  title={`comprar grama batatais em preço m² ${city} ${province} `}
                >
                  comprar grama batatais em preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href={`https://centraldagrama.com/comprar-grama/${province}/${city}`}
                  title={`comprar grama são carlos preço m² ${city} ${province} `}
                >
                  comprar grama são carlos preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href="https://centraldagrama.com/comprar-grama/{province}/${city}"
                  title={`comprar grama bermuda preço m² sorocaba sp ${city} ${province}`}
                >
                  comprar grama bermuda preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href="https://centraldagrama.com/comprar-grama/{province}/${city}"
                  title={`comprar grama coreana preço m² ${city} ${province}`}
                >
                  comprar grama coreana preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
                ,
                <br />
                <S.TextLink
                  href="https://centraldagrama.com/comprar-grama/sp/sorocaba"
                  title={`comprar grama santo agostinho preço m² ${city} ${province}`}
                >
                  comprar grama santo agostinho preço m² {seo?.local} {seo?.uf}
                </S.TextLink>
              </S.About>
            </S.Left>
          </S.Flex>
        </Container>
      </section>
    </Layout>
  )
}

export async function getStaticPaths() {
  const paths = estadosCidades.reduce((acc, estado) => {
    return [
      ...acc,
      ...estado.cidades.map((cidade) => ({
        params: {
          province: estado.sigla.toLocaleLowerCase(),
          city: transformarParaUrlAmigavel(cidade),
        },
      })),
    ]
  }, [])

  return {
    paths,
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  const info = findCityByUrl(params.city, params.province)

  return {
    props: {
      ...params,
      seo: info,
    },
  }
}

export default Contato
